import React from "react";
import theme from "app/Theme/Theme";
import Svg, {
  Circle,
  Defs,
  LinearGradient,
  Path,
  Stop,
} from "react-native-svg";
import normalize from "app/utils/normalize";

const PulseNotification = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.white"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Circle cx={12} cy={12} r={12} fill="#007EFC" />
    <Circle cx={12} cy={12} r={12} fill="url(#PulseNotification1)" />
    <Path
      d="M15.928 10.45a.444.444 0 0 0-.372-.2h-3.111V5.438a.439.439 0 0 0-.353-.428.444.444 0 0 0-.498.25l-3.556 7.875a.43.43 0 0 0 .034.416c.082.124.222.2.372.2h3.112v4.812A.44.44 0 0 0 12 19a.445.445 0 0 0 .406-.26l3.556-7.875a.43.43 0 0 0-.034-.415Z"
      fill={color}
    />
    <Defs>
      <LinearGradient
        id="PulseNotification1"
        x1={12}
        y1={0}
        x2={12}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset="0" stopColor="#22B4FD" />
        <Stop offset="1" stopColor="#0465E1" />
      </LinearGradient>
    </Defs>
  </Svg>
);

export default PulseNotification;
